// Rutas compartidas entre el router (App.js) y las redirecciones de sesión,
// para no repetir el string a mano. Si cambia RUTA_LOGIN, actualizar también
// "start_url" en public/manifest.json (la app instalada abre directo ahí).

// Landing pública: es lo primero que ve quien entra al dominio
export const RUTA_LANDING = "/";

// Inicio de sesión (antes estaba en "/")
export const RUTA_LOGIN = "/login";

// Pantalla inicial después de iniciar sesión
export const RUTA_INICIO = "/home";
